import React, { useState, useRef } from "react";
import CloseIcon from "../images/close-icon-white.svg";
import Stitch from "../images/stitch-logo.svg";
import Qlik from "../images/qlik-logo.svg";
import Talend from "../images/talend-logo.svg";
import { experiences } from "../data";

const JobModal = ({ job, callback }) => {
    const modalRef = useRef();

    const companyLogos = {
      "Stitch": Stitch,
      "Talend": Talend,
      "Qlik": Qlik,
    }

    const handleClickOutside = (event) => {
	if (modalRef.current && !modalRef.current.contains(event.target)) {
	    closeModal();
	}
    };

    const closeModal = () => {
	callback(null);
	document.getElementById("html").classList.remove("locked");
    };

    document.addEventListener("mousedown", handleClickOutside);

    if (job === null || job === undefined) return null;

    const { jobTitle, company, date, description, jobs } = experiences[job];

    return (
	<div className="job-modal-container">
	    <div ref={modalRef} className="job-modal">
		<div className="bg-dark-text d-flex justify-content-end position-fixed w-100 py-4 pe-4">
		    <div className="d-flex align-items-center pointer" onClick={closeModal}>
			<div className="me-2">close</div>
			<img className="close-icon" src={CloseIcon} alt="close" />
		    </div>
		</div>
		<div className="job-modal-info m-auto">
		    <div className="d-flex justify-content-between">
			<div>
			    <h2>{jobTitle}</h2>
			    <div className="d-flex align-items-end">
				{company && <img className="job-logo" src={companyLogos[company]} alt={company} />}
				<div className="mt-3 fst-italic text-white-50">
				    <h4 className="fw-bold mb-1">{company}</h4>
				    <h6 className="fst-italic">{date}</h6>
				</div>
			    </div>
			</div>
		    </div>
		    <div className="divider my-4" />
		    <p className="mt-5">{description}</p>
		    <ul className="mt-4">
			{jobs.map((job, index) => (
			    <li key={index}><p>{job}</p></li>
			))}
		    </ul>
		</div>
		<div className="fade-div" />
	    </div>
	</div>
    );
};

export default JobModal;
